const translations = {
  "en": {
    "Brokerages, retirement, robo-advisors": "Brokerages, retirement, robo-advisors",
    "Checking, savings, credit cards": "Checking, savings, credit cards",
    "Close": "Close",
    "Connect banking account": "Connect banking account",
    "Connect investment account": "Connect investment account",
    "Go back": "Go back",
    "How would you like to connect?": "How would you like to connect?",
    "Pick one to start. You can add the rest any time.": "Pick one to start. You can add the rest any time."
  },
  "zh-tw": {
    "Brokerages, retirement, robo-advisors": "券商、退休帳戶、智能投顧",
    "Checking, savings, credit cards": "支票帳戶、儲蓄帳戶、信用卡",
    "Close": "關閉",
    "Connect banking account": "綁定銀行帳戶",
    "Connect investment account": "連接投資帳戶",
    "Go back": "返回",
    "How would you like to connect?": "你想用哪種方式連結？",
    "Pick one to start. You can add the rest any time.": "選取一項開始。其餘項目可隨時新增。"
  }
};

export default translations;
